const InputErrorMessage = ({ children }) => {
  return <p className="error-message">{children}</p>;
};

export default InputErrorMessage;
